import { isEmpty } from 'componentregistry';

export function getAvatarChars(value?: string | null) {
  if (isEmpty(value)) return '...';
  const len = value.length;
  let char = '';
  let avatar = '';
  let wordStart = true;
  for (let i = 0; i < len; i++) {
    char = value.charAt(i);
    switch (char) {
      case ' ':
      case '_':
      case '-':
      case '.':
      case '@':
        wordStart = true;
        break;
      default:
        if (wordStart) {
          avatar += char.toUpperCase();
          if (avatar.length === 2) {
            return avatar;
          }
          wordStart = false;
        }
        break;
    }
  }
  return avatar;
}
